var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.31225 22.0217H17.312C18.311 22.0217 19.124 21.2087 19.124 20.2097V8.02148H21.125V6.39623H17.1252V4.20923C17.1252 3.20948 16.3123 2.39648 15.3125 2.39648H9.3125C8.31275 2.39648 7.49975 3.20948 7.49975 4.20923V6.39698H3.5V8.02148H5.50025V20.209C5.50025 21.2087 6.31325 22.0217 7.31225 22.0217ZM9.125 4.02173H15.5V6.39698H9.125V4.02173ZM7.12475 8.02148H17.4995L17.501 20.3965H7.12475V8.02148Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1252 10.3967H13.5V18.022H15.1252V10.3967Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1252 10.3967H9.5V18.022H11.1252V10.3967Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsTrash);
export default __webpack_public_path__ + "static/media/icons-trash.bda8dad0905f1f8380fea016ec78b5ac.svg";
export { ForwardRef as ReactComponent };